import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Search } from 'assets/svg/icon-search.svg'

function IconSearch(props: IconProps): JSX.Element {
  const title = 'icon-search'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Search {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconSearch
